import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SvgIcon } from '../../../../../../../cross-team-shared/icons/create-icon-definition';
import { EditMode3D } from '../../../../../../../cross-team-shared/types/tool-modes';
import { faceOfInterestModeIcon } from '../../../../../../shared/icons/toolbars/face-of-interest-mode-icon';
import { rotateCuboidModeIcon } from '../../../../../../shared/icons/toolbars/rotate-cuboid-mode-icon';
import { translateModeIcon } from '../../../../../../shared/icons/toolbars/translate-mode-icon';
import { AbstractToolModeSecondaryToolbar } from '../abstract-tool-mode-secondary-toolbar';

@Component({
  selector: 'h3-edit-tool-3d-secondary-toolbar',
  templateUrl: './edit-tool-3d-secondary-toolbar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EditTool3dSecondaryToolbarComponent extends AbstractToolModeSecondaryToolbar {
  buttons: Array<{ value: EditMode3D; icon: SvgIcon; tooltip: string }> = [
    {
      value: 'translate',
      icon: translateModeIcon,
      tooltip: 'Translate mode / Pan: cuboid',
    },
    {
      value: 'rotate',
      icon: rotateCuboidModeIcon,
      tooltip: 'Rotate mode: cuboid',
    },
    {
      value: 'select face',
      icon: faceOfInterestModeIcon,
      tooltip: 'Face of interest',
    },
  ];

  protected override toolName = 'Edit' as const;

  constructor() {
    super();

    const editModes = this.buttons.map((button) => button.value);
    this.subscribeTo(
      this.keyboardShortcutService.getEvent$('selectEditTool'),
      () => {
        this.cycleToNextMode(editModes);
      },
    );
  }
}
